// ** MUI Theme Provider
import { deepmerge } from '@mui/utils'

// ** Theme Override Imports
import breakpoints from './breakpoints'
import overrides from './overrides'
import palette from './palette'
import shadows from './shadows'
import { themeSpacing } from './spacing'
import typography from './typography'

const themeOptions = (settings, overrideMode) => {
  // ** Vars
  const { skin, mode, tenantConfig } = settings

  const mergedThemeConfig = deepmerge({
    breakpoints: breakpoints(),
    components: overrides(settings),
    palette: palette(mode === 'semi-dark' ? overrideMode : mode, skin),
    ...themeSpacing,
    shape: {
      borderRadius: 6
    },
    mixins: {
      toolbar: {
        minHeight: 64
      }
    },
    shadows: shadows(mode === 'semi-dark' ? overrideMode : mode),
    typography
  })

  return deepmerge(mergedThemeConfig, {
    palette: {
      primary: {
        ...(mergedThemeConfig.palette
          ? mergedThemeConfig.palette[
              tenantConfig?.primaryColor || 'primary'
            ] || { main: tenantConfig?.primaryColor || 'primary' }
          : palette(mode === 'semi-dark' ? overrideMode : mode, skin).primary)
      }
    }
  })
}

export default themeOptions
